import { Component, Input } from '@angular/core';
import { number } from 'echarts';
import { OutputStructure } from '../../helperFunctions/evalValFromObj';

@Component({
  selector: 'app-accordion-ui',
  templateUrl: './accordion-ui.component.html',
  styleUrls: ['./accordion-ui.component.css']
})
export class AccordionUiComponent {

  @Input() showHeader: boolean = false
  @Input() headerTitles: string[] | number[]= []
  @Input() data: OutputStructure = [];

  @Input() showFooter: boolean = false
  @Input() footerTitles: string[] = []

  constructor() { }
}
